import { useTranslation } from 'react-i18next'
import { ProjectProgressCard } from './ProjectProgressCard'
import type { OngoingProject } from '../types/home.types'

interface OngoingProjectsListProps {
  projects: OngoingProject[]
}

export function OngoingProjectsList({ projects }: OngoingProjectsListProps) {
  const { t } = useTranslation()

  return (
    <div className="mb-8">
      {/* Section Header */}
      <div className="mb-3 flex items-baseline gap-2">
        <h2 className="text-foreground text-base font-bold">{t('home.myTasks')}</h2>
        <span className="text-muted-foreground text-xs">{t('home.ongoingProjects')}</span>
      </div>

      {/* Projects Container */}
      <div className="border-border bg-card text-card-foreground overflow-hidden rounded-lg border">
        {projects.length === 0 ? (
          <div className="text-muted-foreground p-8 text-center text-sm">
            {t('home.noOngoingProjects')}
          </div>
        ) : (
          projects.map((project) => <ProjectProgressCard key={project.id} project={project} />)
        )}
      </div>
    </div>
  )
}
